import React from 'react';
import { Button, Badge } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/actions/alertAction';

const InfoItem = ({ label, value, badge, variant, copyable }) => {
  const dispatch = useDispatch();

  const handleCopy = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        dispatch(showAlert(`${label} copied to clipboard!`, 'success'));
      })
      .catch((err) => {
        dispatch(showAlert(`Failed to copy ${label} to clipboard!`, 'danger'));
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="text-secondary" style={{ fontSize: '0.9rem' }}>
        {label}
      </div>
      <div className="d-flex align-items-center gap-2 justify-content-end">
        {badge ? (
          <Badge bg={variant} className="text-uppercase" style={{ fontSize: '0.85rem' }}>
            {value}
          </Badge>
        ) : (
          <span className="text-dark" style={{ fontSize: '0.9rem' }}>
            {value}
          </span>
        )}
        {copyable && (
          <Button variant="link" size="sm" className="p-0 ms-2" onClick={handleCopy}>
            <i className="fas fa-copy" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default InfoItem;
